import React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon/SvgIcon'
import { SvgIconProps } from '@material-ui/core'

/**
 * Figma link: https://www.figma.com/file/3z9SovcAVVWRw6bR0jPFLc/UI_library_2.0?node-id=5661%3A8536
 *
 * @param {SvgIconProps} props - svg props
 */
export const SplitIcon = (props: SvgIconProps): JSX.Element => {
    const color = props.color || 'currentColor'
    const svgProps = Object.assign({}, props)
    delete svgProps.color
    return (
        <SvgIcon {...svgProps} width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path fillRule='evenodd' clipRule='evenodd' d='M9.56421 3.92643L7.15 6.35L13.6055 12.617C13.8577 12.8618 14 13.1983 14 13.5498V20.5C14 20.7761 13.7761 21 13.5 21C13.2238 21 12.2761 21 12 21C11.7238 21 11.5 20.7761 11.5 20.5L11.5 14.108C11.5 14.0391 11.4715 13.9732 11.4213 13.926L5.34 8.2L2.92552 10.5805C2.76752 10.7362 2.5 10.6243 2.5 10.4024V3.75C2.5 3.61193 2.61193 3.5 2.75 3.5H9.38709C9.60958 3.5 9.72123 3.7688 9.56421 3.92643ZM14.4358 3.92643L16.85 6.35L13.434 9.62967C13.333 9.72667 13.3313 9.88774 13.4304 9.98678L14.9083 11.4647C15.0045 11.5609 15.1601 11.5625 15.2582 11.4682L18.66 8.2L21.0745 10.5805C21.2325 10.7362 21.5 10.6243 21.5 10.4024V3.75C21.5 3.61193 21.388 3.5 21.25 3.5H14.6129C14.3904 3.5 14.2787 3.7688 14.4358 3.92643Z' fill={color}/>
        </SvgIcon>
    )
}

export default SplitIcon
